import { useState, useRef, useEffect } from 'react';
import { compose, tap, always } from 'ramda';

import { useErrorNotifier } from 'shared/custom-hooks/useNotifiers';
import { useSelector } from 'react-redux';
import { selectSelectedCompany } from 'companies/companies.slice';
import { selectParticipant } from 'participant-search/participant.slice';
import { getInvoiceDetails } from 'shared/api/invoicesApi';
import { NonPlanYearInvoiceDetail } from './view-invoices.types';

export function useInvoiceDetails(isCobra: boolean, invoiceNumber: number) {
  const errorNotifier = useErrorNotifier();
  const { compid } = useSelector(selectSelectedCompany) ?? { compid: 0 };
  const { empno } = useSelector(selectParticipant) ?? { empno: 0 };

  const [ invoiceDetails, setInvoiceDetails ] = useState<NonPlanYearInvoiceDetail[] | null>(null);

  const [ setDefault ] = useState(() => compose(setInvoiceDetails, always([])));
  const [ handleError ] = useState(() => compose(tap(setDefault), errorNotifier));
  const mountedRef = useRef(false);

  useEffect(() => {
    mountedRef.current = true;

    getInvoiceDetails(compid, isCobra, empno.toString(), invoiceNumber)
      .then((result) => {
        if (mountedRef.current) {
          setInvoiceDetails(result ?? []);
        }
      })
      .catch((err) => {
        if (mountedRef.current) {
          handleError(err);
        }
      });

    return () => {
      mountedRef.current = false;
    };
  }, [ handleError, compid, isCobra, empno, invoiceNumber ]);

  return invoiceDetails;
}
